import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../../shared/utils/utils";
import { RootState } from "../../../shared/types/common";
import { Alert, Button, Drawer, Form, Modal, Tooltip, Upload, UploadFile } from "antd";
import GenericFormComponent from "../../../shared/components/generic-form/generic-form.component";
import { useForm } from "antd/lib/form/Form";
import { useNavigate } from "react-router-dom";
import {
  createStaff,
  updateStaffById,
} from "../../../core/store/reducers/staff.slice";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Client } from "../../../core/api-client";
import {
  API_GET_ALL_ACCOUNTS_LIST,
  API_GET_ALL_DEPARTMENT_LIST,
  API_GET_ALL_PROJECT_LIST,
  API_GET_ALL_STAFF_LIST,
  API_GET_ALL_VENDOR_LIST,
  ROUTE_MANAGE_STAFF,
} from "../../../shared/routes/private.routes";
import {
  ExclamationCircleOutlined,
  InboxOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  getDocuments,
  getSignedUrl,
} from "../../../core/store/reducers/activity-log.slice";
import { getSubDepartmentsByDepartment } from "../../../core/store/reducers/sub-department.slice";
import { requestGetByModuleCommon } from "../../../core/store/reducers/master.slice";
import { getAccountsByEntity } from "../../../core/store/reducers/accounts.slice";
const NOTICE_PERIOD_STATUS = "NOTICE PERIOD";
const DEFAULT_STAFF_EMAIL_DOMAIN = "@roboticodigital.com";
const INNOTHRUST_EMAIL_DOMAIN = "@innothrust.com";
const INNOTHRUST_ENTITY_NAME = "innothrust";

interface Props {
  onClose: () => void;
  visible: boolean;
  selectedEntity?: any;
  onSubmit?: (staffId?: string) => void;
}
const CreateEditStaffComponent = ({
  onClose,
  visible,
  selectedEntity = null,
  onSubmit = () => {
    return;
  },
}: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const watchedEmploymentMode = Form.useWatch("employmentMode", form);
  const watchedVendorEmploymentType = Form.useWatch("vendorEmploymentType", form);
  const watchedJoiningDate = Form.useWatch("doj", form);
  const { user } = useSelector((state: RootState) => state.auth);
  const { screenType } = useSelector((state: RootState) => state.settings);
  const [staffList, setStaffList] = useState<any[]>([]);
  const [projectList, setProjectList] = useState<any[]>([]);
  const [genderList, setGenderList] = useState<any[]>([]);
  const [entityList, setEntityList] = useState<any[]>([]);
  const [employmentModes, setEmploymentModes] = useState<any[]>([]);
  const [employeeTypes, setEmployeeTypes] = useState<any[]>([]);
  // const [currencies, setCurrencies] = useState<any[]>([]);
  const [departmentList, setDepartmentList] = useState<any[]>([]);
  const [subDepartmentList, setSubDepartmentList] = useState<any[]>([]);
  const [vendorList, setVendorList] = useState<any[]>([]);
  const [selectedStartDate, setSelectedStartDate] = useState<any>(null);
  const [showVendorField, setShowVendorField] = useState<boolean>(false);
  const [showContractFields, setShowContractFields] = useState<boolean>(false);
  const [showNextReviewDate, setShowNextReviewDate] = useState<boolean>(false);
  const [showMalaysiaPassportVisa, setShowMalaysiaPassportVisa] = useState<boolean>(false);
  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [departmentId, setDepartmentId] = useState<any>("")
  const [accountList, setAccountList] = useState<any[]>([]);
  const [filteredProjectList,setFilteredProjectList] = useState<any[]>([]);
  const [isNoticePeriodStatus, setIsNoticePeriodStatus] = useState<boolean>(
    selectedEntity?.staffStatusId === NOTICE_PERIOD_STATUS
  );

  const findEmploymentMode = (value: any) =>
    employmentModes.find(
      (mode) =>
        String(mode?.id) === String(value) ||
        String(mode?.name) === String(value)
    );
  const selectedEmploymentMode = findEmploymentMode(watchedEmploymentMode);
  const selectedVendorEmploymentMode = findEmploymentMode(watchedVendorEmploymentType);
  const selectedEmploymentModeName = String(selectedEmploymentMode?.name || "");
  const isVendorConsultant = /vendor consultant/i.test(selectedEmploymentModeName);
  const showInternDates =
    /^intern$/i.test(selectedEmploymentModeName) ||
    (isVendorConsultant && /^intern$/i.test(String(selectedVendorEmploymentMode?.name || "")));
  const showTrainingDates =
    /^(trainee|training)$/i.test(selectedEmploymentModeName) ||
    (isVendorConsultant && /^(trainee|training)$/i.test(String(selectedVendorEmploymentMode?.name || "")));
  const periodStartTimestamp =
    watchedJoiningDate && dayjs(watchedJoiningDate).isValid()
      ? dayjs(watchedJoiningDate).valueOf()
      : null;

  useEffect(() => {
    const employmentPeriodDates: Record<string, any> = {
      internStartDate: null,
      internEndDate: null,
      traineeStartDate: null,
      traineeEndDate: null,
    };

    const periodStart =
      periodStartTimestamp !== null ? dayjs(periodStartTimestamp) : null;
    if (periodStart && showInternDates) {
      employmentPeriodDates.internStartDate = periodStart;
      employmentPeriodDates.internEndDate = periodStart.add(6, "month");
    } else if (periodStart && showTrainingDates) {
      employmentPeriodDates.traineeStartDate = periodStart;
      employmentPeriodDates.traineeEndDate = periodStart.add(11, "month");
    }

    form.setFieldsValue(employmentPeriodDates);
  }, [form, periodStartTimestamp, showInternDates, showTrainingDates]);

  const hasInactiveDependencyError = (data: any) => {
    const dependencies = data?.dependencies;
    return (
      dependencies &&
      Object.keys(dependencies).some(
        (key) => Array.isArray(dependencies[key]) && dependencies[key].length > 0
      )
    );
  };

  const dependencySections = (dependencies: any) =>
    [
      {
        key: "projectManagerProjects",
        title: "Project Manager for active projects",
        nameKey: "projectName",
        items: dependencies?.projectManagerProjects || [],
      },
      {
        key: "accountManagerProjects",
        title: "Account Manager for active projects",
        nameKey: "projectName",
        items: dependencies?.accountManagerProjects || [],
      },
      {
        key: "primaryProjects",
        title: "Assigned primary project",
        nameKey: "projectName",
        items: dependencies?.primaryProjects || [],
      },
      {
        key: "assignedProjects",
        title: "Current/future active project allocations",
        nameKey: "projectName",
        items: dependencies?.assignedProjects || [],
      },
      {
        key: "managedStaff",
        title: "Line manager for active staff",
        nameKey: "staffName",
        items: dependencies?.managedStaff || [],
      },
    ].filter((section) => section.items.length > 0);

  const showInactiveDependencyModal = (data: any) => {
    Modal.warning({
      title: "Staff cannot be marked inactive",
      width: 620,
      closable: true,
      content: (
        <div className="staff-inactive-dependency-modal">
          <Alert
            type="warning"
            showIcon
            message="Please remove these active dependencies before changing the staff status to inactive."
          />
          <div className="staff-inactive-dependency-list">
            {dependencySections(data?.dependencies).map((section) => (
              <div className="staff-inactive-dependency-section" key={section.key}>
                <div className="staff-inactive-dependency-title">
                  {section.title}
                  <span>{section.items.length}</span>
                </div>
                <ul>
                  {section.items.map((item: any, index: number) => (
                    <li key={`${section.key}-${item.projectId || item.staffId || index}`}>
                      <span>{item[section.nameKey] || "-"}</span>
                      {(item.employeeId || item.month) && (
                        <small>
                          {item.employeeId ||
                            `${item.month}${item.percentAllocation ? ` / ${item.percentAllocation}%` : ""}`}
                        </small>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      ),
      okText: "Got it",
    });
  };

  const handleStaffSaveError = (data: any) => {
    if (data?.message === "staffAlreadyExistMessage") {
      showNotification("Staff Already Exist", "warning");
      return;
    }
    if (hasInactiveDependencyError(data)) {
      showInactiveDependencyModal(data);
      return;
    }
    showNotification(data?.message, "warning");
  };

  const toDateOnly = (value: any) => {
    if (!value) return null;
    return dayjs(value).isValid() ? dayjs(value).format("YYYY-MM-DD") : null;
  };

  // Keep the Create Staff rule aligned with Staff Profile/Edit: this field is
  // applicable for Trainee/Intern, including a Vendor Consultant whose vendor
  // employment mode is Trainee/Intern.
  const isNextReviewDateApplicable = (
    employmentModeId: any,
    vendorEmploymentTypeId: any
  ) => {
    const findByIdOrName = (items: any[], value: any) =>
      items.find(
        (item: any) =>
          String(item?.id) === String(value) ||
          String(item?.name) === String(value)
      );
    const selectedEmploymentMode = findByIdOrName(employmentModes, employmentModeId);
    const employmentModeName = String(selectedEmploymentMode?.name || "");
    const employmentModeIsTraineeOrIntern = /trainee|intern/i.test(employmentModeName);
    const isVendorConsultant = /vendor consultant/i.test(employmentModeName);
    // Create Staff currently sources this dropdown from employeeTypes, while
    // Staff Profile/Edit resolves it from employmentModes. Check that source as
    // a fallback so the same name-based Trainee/Intern rule is applied.
    const vendorEmploymentType =
      findByIdOrName(employmentModes, vendorEmploymentTypeId) ||
      findByIdOrName(employeeTypes, vendorEmploymentTypeId);
    const vendorEmpIsTraineeOrIntern = /trainee|intern/i.test(
      String(vendorEmploymentType?.name || "")
    );

    return (
      employmentModeIsTraineeOrIntern ||
      (isVendorConsultant && vendorEmpIsTraineeOrIntern)
    );
  };

  const updateNextReviewDateVisibility = (
    employmentModeId: any,
    vendorEmploymentTypeId: any
  ) => {
    const shouldShow = isNextReviewDateApplicable(
      employmentModeId,
      vendorEmploymentTypeId
    );
    setShowNextReviewDate(shouldShow);
    if (!shouldShow) {
      form.setFieldsValue({ nextReviewDate: null });
    }
    return shouldShow;
  };

  const parsePositionHistory = (value: any): any[] => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  const getLineManagerName = (lineManagerId: string) =>
    staffList.find((staff) => staff?.staffId === lineManagerId)?.staffName || "";

  const buildInitialPositionHistory = (values: any, effectiveFrom: string | null) => {
    if (!effectiveFrom) return [];
    return [
      {
        effectiveFrom,
        designation: values?.designation || "",
        reportingTo: getLineManagerName(values?.linemanager),
      },
    ];
  };

  const normalizePositionHistoryPayload = (rows: any[]) =>
    rows
      .filter((row) => row?.effectiveFrom || row?.designation || row?.reportingTo)
      .map((row) => ({
        effectiveFrom: toDateOnly(row?.effectiveFrom),
        designation: row?.designation || "",
        reportingTo: row?.reportingTo || "",
      }));

  const onFinish = async (values: any) => {
    // Split fileList into two groups
    const oldFiles = fileList.filter((file) => !file.originFileObj); // previously uploaded
    const newFiles = fileList.filter((file) => file.originFileObj); // new uploads
    const formData = new FormData();
    const doj = toDateOnly(values.doj);
    const contractStartDate = toDateOnly(values.contractStartDate);
    const contractEndDate = toDateOnly(values.contractEndDate);
    const previousSalaryRevisionDate = toDateOnly(values.previousSalaryRevisionDate);
    const nextSalaryRevisionDate = toDateOnly(values.nextSalaryRevisionDate);
    const nextReviewDate = toDateOnly(values.nextReviewDate);
    const passportExpiryDate = toDateOnly(values.passportExpiryDate);
    const visaExpiryDate = toDateOnly(values.visaExpiryDate);
    const lwd = toDateOnly(values?.lwd) || toDateOnly(selectedEntity?.lwd);
    const currentProjectStartDate = toDateOnly(values?.currentProjectStartDate);
    const projectReleaseDate = toDateOnly(values?.projectReleaseDate);

    // Append all string/number fields
    formData.append("staffName", values?.staffName);
    formData.append("employeeType", values?.employeeType);
    formData.append("employeeId", values?.employeeId);
    formData.append("email", values?.email || "");
    formData.append("gender", values?.gender || "");
    formData.append("staffTypeId", values?.type || "");
    formData.append("staffSubTypeId", values?.subtype || "");
    formData.append("staffStatusId", selectedEntity?.staffStatusId === "DRAFT" ? "DRAFT" : selectedEntity ? values?.staffStatus : "DRAFT");
    formData.append("doj", doj || "");
    formData.append("contractStartDate", showContractFields ? contractStartDate || doj || "" : "");
    formData.append("contractEndDate", showContractFields ? contractEndDate || "" : "");
    formData.append("previousSalaryRevisionDate", previousSalaryRevisionDate || "");
    formData.append("nextSalaryRevisionDate", nextSalaryRevisionDate || "");
    formData.append("passportNumber", values?.passportNumber || "");
    formData.append("passportExpiryDate", showMalaysiaPassportVisa ? passportExpiryDate || "" : "");
    formData.append("visaType", showMalaysiaPassportVisa ? values?.visaType || "" : "");
    formData.append("visaExpiryDate", showMalaysiaPassportVisa ? visaExpiryDate || "" : "");
    if (
      !selectedEntity &&
      isNextReviewDateApplicable(values?.employmentMode, values?.vendorEmploymentType) &&
      nextReviewDate
    ) {
      formData.append("nextReviewDate", nextReviewDate);
    }
    if (showInternDates) {
      formData.append("internStartDate", toDateOnly(values?.internStartDate) || "");
      formData.append("internEndDate", toDateOnly(values?.internEndDate) || "");
    } else if (showTrainingDates) {
      formData.append("traineeStartDate", toDateOnly(values?.traineeStartDate) || "");
      formData.append("traineeEndDate", toDateOnly(values?.traineeEndDate) || "");
    }
    formData.append("lwd", lwd || "");
    formData.append("departmentId", values?.department);
    formData.append("subDepartmentId",values?.subDepartment || "");
    formData.append("accountId", values?.client || "");
    formData.append("projectId", values?.project || "");
    formData.append("subProjectId", values?.subProject || "");
    formData.append("projectReleaseDate", projectReleaseDate || "");
    formData.append("currentProjectStartDate", currentProjectStartDate || "");
    formData.append("lineManagerId", values?.linemanager || "");
    formData.append("vendorId", values?.vendor || "");
    formData.append("vendorEmpId", showVendorField ? values?.vendorEmpId || "" : "");
    formData.append("vendorEmploymentType", showVendorField ? values?.vendorEmploymentType || "" : "");
    formData.append("entity", values?.entity);
    formData.append("employmentMode", values?.employmentMode);
    formData.append("designation", values?.designation || "");
    formData.append("role", values?.role || "");
    formData.append("noticePeriod", values?.noticePeriod || "");
    formData.append("costToRd", values?.costToRd || "");

    const submittedPositionHistory = normalizePositionHistoryPayload(
      parsePositionHistory(values?.positionHistory)
    );
    const existingPositionHistory = parsePositionHistory(selectedEntity?.positionHistory);
    const positionHistoryPayload =
      submittedPositionHistory.length > 0
        ? submittedPositionHistory
        : !selectedEntity || existingPositionHistory.length === 0
          ? buildInitialPositionHistory(values, doj)
          : null;
    if (positionHistoryPayload) {
      formData.append("positionHistory", JSON.stringify(positionHistoryPayload));
    }

    // Salary fields are temporarily hidden.
    // if(!selectedEntity){
    //   formData.append("salaryCurrency",values?.salaryCurrency)
    //   // formData.append("ctc", values?.ctc);
    //   let {encrypted_ctc, iv, salt} = await encryptCTC(dayjs().format("YYYY-MM-DD"), values?.ctc?.toString());
    //   formData.append("encrypted_ctc", encrypted_ctc);
    //   formData.append("iv", iv);
    //   formData.append("salt", salt);
    //   // formData.append("employeeCost", values?.employeeCost || "");
    // }

    // Append file (assuming single file upload)
    if (fileList && newFiles.length > 0) {
      newFiles.forEach((fileItem) => {
        const file = fileItem;
        formData.append("files", file.originFileObj as File); // use consistent key name
      });
    }
    const remainingOldFiles = oldFiles.map((file) => ({
      uid: file.uid,
      name: file.name,
      url: file.url,
    }));
    formData.append("oldFiles", JSON.stringify(remainingOldFiles));
    
      dispatch(createStaff(formData)).then((val: any) => {
        if (val?.payload?.data && val?.payload?.data?.statusCode === 200) {
          showNotification("New Staff Created in Draft", "success");
          const newStaffId = val?.payload?.data?.data?.staffId;
          onSubmit(newStaffId);
          navigate(`${ROUTE_MANAGE_STAFF}/${newStaffId}`, {
                state: { staff: val?.payload?.data?.data },
              });
        }
        if (val?.payload?.data && val?.payload?.data?.statusCode === 400) {
          handleStaffSaveError(val?.payload?.data);
        }
      });
    
  };

  const fetchStaffList = async () => {
    const response = await Client.get(API_GET_ALL_STAFF_LIST);
    if (response?.data?.data) {
      setStaffList(response?.data?.data);
    } else {
      setStaffList([]);
    }
  };

  const fetchProjectList = async () => {
    const response = await Client.get(API_GET_ALL_PROJECT_LIST);
    if (response?.data?.data) {
      setProjectList(response?.data?.data);
    } else {
      setProjectList([]);
    }
  };

  const fetchFilteredProjectList = async (clientId: string) => {
    const response = projectList.filter((project:any)=>project.accountId === clientId);
    setFilteredProjectList(response);
  };
  const fetchDepartmentList = async () => {
    const response = await Client.get(API_GET_ALL_DEPARTMENT_LIST);
    if (response?.data?.data) {
      setDepartmentList(response?.data?.data);
    } else {
      setDepartmentList([]);
    }
  };

  const fetchVendorList = async () => {
    const response = await Client.get(API_GET_ALL_VENDOR_LIST);
    if (response?.data?.data) {
      setVendorList(response?.data?.data);
    } else {
      setVendorList([]);
    }
  };

  useEffect(() => {
    if (selectedEntity) {
      form.setFieldsValue({
        staffName: selectedEntity?.staffName,
        employeeType: selectedEntity?.employeeType,
        employeeId: selectedEntity?.employeeId,
        email: selectedEntity?.email,
        gender: selectedEntity.gender,
        type: selectedEntity?.staffTypeId,
        subtype: selectedEntity?.staffSubTypeId,
        staffStatus: selectedEntity?.staffStatusId,
        doj: selectedEntity?.doj ? dayjs(selectedEntity?.doj) : null,
        contractStartDate: selectedEntity?.contractStartDate
          ? dayjs(selectedEntity?.contractStartDate)
          : selectedEntity?.doj
          ? dayjs(selectedEntity?.doj)
          : null,
        contractEndDate: selectedEntity?.contractEndDate
          ? dayjs(selectedEntity?.contractEndDate)
          : null,
        previousSalaryRevisionDate: selectedEntity?.previousSalaryRevisionDate
          ? dayjs(selectedEntity?.previousSalaryRevisionDate)
          : null,
        nextSalaryRevisionDate: selectedEntity?.nextSalaryRevisionDate
          ? dayjs(selectedEntity?.nextSalaryRevisionDate)
          : null,
        lwd: selectedEntity?.lwd ? dayjs(selectedEntity?.lwd) : null,
        department: selectedEntity?.departmentId,
        subDepartment: selectedEntity?.subDepartmentId || null,
        client: selectedEntity?.accountId || null,
        project: selectedEntity?.projectId || null,
        subProject: selectedEntity?.subProjectId || null,
        projectReleaseDate: selectedEntity?.projectReleaseDate
          ? dayjs(selectedEntity?.projectReleaseDate)
          : null,
        currentProjectStartDate: selectedEntity?.currentProjectStartDate
        ? dayjs(selectedEntity?.currentProjectStartDate)
        : null,
        linemanager: selectedEntity?.lineManagerId || null,
        // ctc: selectedEntity?.ctc,
        vendor: selectedEntity?.vendorId,
        vendorEmpId: selectedEntity?.vendorEmpId || null,
        vendorEmploymentType: selectedEntity?.vendorEmploymentType || null,
        entity: selectedEntity?.entity,
        employmentMode: selectedEntity?.employmentMode,
        designation: selectedEntity?.designation || null,
        role: selectedEntity?.role || null,
        noticePeriod: selectedEntity?.noticePeriod || null,
        // employeeCost: selectedEntity?.employeeCost || null,
        costToRd: selectedEntity?.costToRd || null,
        // salaryCurrency: selectedEntity?.salaryCurrency
      });
      setIsNoticePeriodStatus(selectedEntity?.staffStatusId === NOTICE_PERIOD_STATUS);
      const filterEmploymentMode = employmentModes.find((type:any)=>type.name === 'Vendor Consultant')
      if (selectedEntity?.employmentMode === filterEmploymentMode?.id) {
        setShowVendorField(true); // Show vendor field if employee type is Vendor
      }
      const permanentEmploymentMode = employmentModes.find((type:any)=>type.name === 'Permanent');
      setShowContractFields(selectedEntity?.employmentMode !== permanentEmploymentMode?.id);
      setDepartmentId(selectedEntity?.departmentId);
      // const employeeCost = parseFloat((selectedEntity?.ctc / 12).toFixed(2));
      // form.setFieldsValue({ employeeCost });
      fetchAccountListByEntity(selectedEntity?.entity);
      // Only filter projects if projectList is already loaded
      if (selectedEntity?.accountId && projectList.length > 0) {
        fetchFilteredProjectList(selectedEntity?.accountId);
      }
    } else {
      setIsNoticePeriodStatus(false);
    }
  }, [form, selectedEntity, projectList, employmentModes]);

  useEffect(() => {
    fetchStaffList();
    fetchProjectList();
    fetchDepartmentList();
    fetchVendorList();
    fetchDocumentList();
    fetchGenderList();
    fetchEntityList();
    fetchEmploymentModes();
    fetchEmployeeTypes();
    // Salary fields are temporarily hidden.
    // fetchCurrencies();
  }, []);

  const fetchGenderList = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_gender" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setGenderList(response?.data.items);
      }
    } catch (error) {}
  };
  // Salary fields are temporarily hidden.
  // const fetchCurrencies = async () => {
  //   try {
  //     const response = await dispatch(
  //       requestGetByModuleCommon({ module: "master_currency" })
  //     ).unwrap();
  //     // console.log(response.data);
  //     if (response?.success) {
  //       setCurrencies(response?.data.items);
  //     }
  //   } catch (error) {}
  // };
  const fetchEntityList = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_entity" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setEntityList(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchEmploymentModes = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_employment_mode" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setEmploymentModes(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchEmployeeTypes = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_employee_type" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setEmployeeTypes(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchDocumentList = async () => {
    if (!selectedEntity?.staffId) {
      return;
    }
    try {
      const response = await dispatch(
        getDocuments(selectedEntity?.staffId)
      ).unwrap();
      setDocuments(response?.data || []);
    } catch (error) {
      setDocuments([]);
    }
  };
  const fetchAccountListByEntity = async (entity: string) => {
    try {
      const response = await dispatch(getAccountsByEntity(entity)).unwrap();
      if (response?.data?.data) {
        setAccountList(response?.data?.data);
      } else {
        setAccountList([]);
      }
    } catch (error) {
      setAccountList([]);
    }
  };
  useEffect(() => {
    if(departmentId){
      fetchSubDepartmentsList(departmentId);
    }
    
  },[departmentId])
  const fetchSubDepartmentsList = async (departmentId: string) => {
    if (!departmentId) {
      return;
    }
    try {
      const response = await dispatch(
        getSubDepartmentsByDepartment(departmentId)
      ).unwrap();
      setSubDepartmentList(response?.data || []);
    } catch (error) {
      setSubDepartmentList([]);
    }
  };

  useEffect(() => {
    if (documents?.length) {
      const converted = documents.map((doc) => ({
        uid: doc.id,
        name: doc.originalFileName,
        status: "done",
        url: doc.bucketPath || "",
      }));

      // Optional: prevent unnecessary state update
      setFileList((prev: any) => {
        const same = JSON.stringify(prev) === JSON.stringify(converted);
        return same ? prev : converted;
      });
    } else {
      setFileList([]); // Clear fileList if documents are empty
    }
  }, [documents]);

  const staffDropdownOptions = staffList.map((staff) => ({
    value: staff?.staffId,
    label: staff?.staffName,
  }));

  const projectDropdownOptions = filteredProjectList.map((project) => ({
    value: project?.projectId,
    label: project?.l2ProjectName,
  }));

  const departmentDropdownOptions = departmentList.map((department) => ({
    value: department?.departmentId,
    label: department?.departmentName,
  }));
  const subDepartmentDropdownOptions = subDepartmentList.map((subDepartment) => ({
    value: subDepartment?.id,
    label: subDepartment?.subDepartmentName,
  }));

  const getRequiredEmailDomain = (entityId?: string) => {
    const entityName =
      entityList.find((entity) => entity?.id === entityId)?.name ||
      (selectedEntity?.entity === entityId ? selectedEntity?.entityName : "");

    return entityName.trim().toLowerCase() === INNOTHRUST_ENTITY_NAME
      ? INNOTHRUST_EMAIL_DOMAIN
      : DEFAULT_STAFF_EMAIL_DOMAIN;
  };
  const vendorDropdownOptions = vendorList.map((vendor) => ({
    value: vendor?.vendorId,
    label: vendor?.vendorName,
  }));

  const onFinishFailed = (_errorInfo: any) => {
    return;
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    if ("entity" in changedValues) {
      const entityName = entityList.find((entity) => String(entity?.id) === String(changedValues.entity))?.name || "";
      setShowMalaysiaPassportVisa(/malaysia|myr/i.test(entityName));
      if (!/malaysia|myr/i.test(entityName)) {
        form.setFieldsValue({ passportNumber: undefined, passportExpiryDate: null, visaType: undefined, visaExpiryDate: null });
      }
      fetchAccountListByEntity(changedValues.entity);
      form.setFieldsValue({ client: undefined });
      form.validateFields(["email"]).catch(() => undefined);
    }
    // Track start date
    if ("staffStatus" in changedValues) {
      setIsNoticePeriodStatus(changedValues.staffStatus === NOTICE_PERIOD_STATUS);
    }
    if ("doj" in changedValues) {
      setSelectedStartDate(allValues.doj);
      if (showContractFields) {
        form.setFieldsValue({ contractStartDate: allValues.doj || null });
      }
    }
  
    // Toggle vendor field based on employment mode
    if ("employmentMode" in changedValues) {
      const filterEmploymentMode = employmentModes.find((type:any)=>type.name === 'Vendor Consultant')
      const isVendor = changedValues.employmentMode === filterEmploymentMode?.id;
      setShowVendorField(isVendor);
      form.setFieldsValue({
        vendor: undefined,
        vendorEmpId: undefined,
        vendorEmploymentType: undefined,
      }); // Clear vendor fields either way
      const permanentEmploymentMode = employmentModes.find((type:any)=>type.name === 'Permanent');
      const isPermanent = changedValues.employmentMode === permanentEmploymentMode?.id;
      setShowContractFields(!isPermanent);
      form.setFieldsValue({
        contractStartDate: isPermanent ? null : allValues.doj || null,
        contractEndDate: null,
      });
      updateNextReviewDateVisibility(changedValues.employmentMode, undefined);
    }

    if ("vendorEmploymentType" in changedValues) {
      updateNextReviewDateVisibility(
        allValues.employmentMode,
        changedValues.vendorEmploymentType
      );
    }
  
    // Track department change
    if ("department" in changedValues) {
      setDepartmentId(changedValues.department);
    }

    // Salary fields are temporarily hidden.
    // if ("ctc" in changedValues) {
    //   const employeeCost = parseFloat((allValues.ctc / 12).toFixed(2));
    //   form.setFieldsValue({ employeeCost });
    // }
    if ("client" in changedValues) {
      // Clear project when client changes
      form.setFieldsValue({ project: undefined });
      // Only filter if a client is actually selected
      if (changedValues.client) {
        fetchFilteredProjectList(changedValues.client);
      } else {
        // Clear filtered projects if client is cleared
        setFilteredProjectList([]);
      }
    }
  };

  const disabledDate = (current: any) => {
    // Disable dates before the start date
    return !!(current && selectedStartDate && current < dayjs(selectedStartDate).endOf("day"));
  };

  const textOnlyRule = (fieldName: string) => ({
    pattern: /^[A-Za-z\s.'/-]+$/,
    message: `Please enter a valid ${fieldName}. Only letters, spaces, apostrophes ('), dots (.), hyphens (-), and slashes (/) are allowed.`,
  });

  const numberOnlyRule = (fieldName: string) => ({
    pattern: /^\d+$/,
    message: `Please enter a valid ${fieldName}. Only numbers are allowed.`,
  });

  const handleUploadChange = (info: any) => {
    const { file, fileList } = info;

    // Optional: filter duplicates by UID or name
    const uniqueFileList = fileList.filter(
      (file: { uid: any }, index: any, self: any[]) =>
        index === self.findIndex((f) => f.uid === file.uid)
    );

    setFileList(uniqueFileList);

    if (file.status === "done" || !file.status) {
      showNotification(`${file.name} file uploaded successfully.`, "success");
    } else if (file.status === "error") {
      showNotification(`${file.name} file upload failed.`, "error");
    }
  };

  const beforeUpload = async (file: any) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];
  
    const isValidType = allowedTypes.includes(file.type);
  
    if (!isValidType) {
      showNotification("Only PDF or Word files are allowed", "warning");
      return Upload.LIST_IGNORE;
    }
  
    return false; // Prevent auto upload if you're using customRequest
  };

  const handleRemove = (file: any) => {
    // const updatedList = fileList.filter((f) => f.uid !== file.uid);
    // setFileList(updatedList);
  };
  const handleCustomRequest = ({ file, onSuccess }: any) => {
    // Simulate upload success after 0ms
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  var colSpan = screenType?.isPortrait ? 24 : 12;
  const formProps = {
    form: form,
    name: "creat-edit-staff",
    heading: selectedEntity ? "Edit Staff Details" : "Add New Staff",
    initialValues: {
      staffStatus: selectedEntity ? "ACTIVE" : "DRAFT",
      // ctc: 0
    },
    formElements: [
      {
        name: "staffName",
        colSpan: 12,
        label: "Staff Name",
        placeholder: "Enter Staff Name ",
        type: "Input",
        allowClear: true,
        rules: [
          { required: true, message: "Please enter Staff Name" },
          textOnlyRule("Staff Name"),
        ],
      },
      {
        name: "entity",
        label: "Entity",
        placeholder: "Entity",
        type: "Select",
        rules: [{ required: true, message: "Please select Entity" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: entityList?.map((entity) => ({
          value: entity?.id,
          label: entity?.name,
        })),
      },
      {
        name: "employeeId",
        colSpan: 12,
        label: "Employee Id",
        placeholder: "Enter Employee Id",
        type: "Input",
        allowClear: true,
        fieldProps: {
          suffix: (
            <Tooltip title="Format: 2–3 letters followed by 5 digits (e.g., RD12345 or RDM12345)">
              <ExclamationCircleOutlined
                style={{ cursor: "pointer", color: "#999" }}
              />
            </Tooltip>
          ),
        },
        rules: [
          { required: true, message: "Please enter Employee Id" },
          {
            validator: (_: any, value: string) => {
              if (!value) return Promise.resolve();
              const regex = /^[A-Za-z]{2,3}[0-9]{5}$/;
              return regex.test(value)
                ? Promise.resolve()
                : Promise.reject(
                    new Error("Invalid format. Please check the Info.")
                  );
            },
          },
        ],
      },
      {
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        type: "Input",
        rules: [
          {
            required: false,
            message: "Please enter Email",
          },
          {
            type: "email",
            message: "Please enter a valid Email",
          },
          {
            validator: (_: any, value: string) => {
              // Only run this validator if there is a value
              if (!value) return Promise.resolve(); // Let "required" handle empty

              // Run only if the value is a valid email first (optional defensive check)
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(value)) return Promise.resolve(); // Let 'type: email' handle this

              const requiredDomain = getRequiredEmailDomain(form.getFieldValue("entity"));

              if (value.toLowerCase().endsWith(requiredDomain)) return Promise.resolve();

              return Promise.reject(
                new Error(`Email must end with ${requiredDomain}`)
              );
            },
          },
        ],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
      },
      {
        name: "gender",
        label: "Gender",
        placeholder: "Gender",
        type: "Select",
        rules: [{ required: true, message: "Please enter Gender" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: genderList?.map((gender) => ({
          value: gender?.id,
          label: gender?.name,
        })),
      },
      selectedEntity?.staffStatusId !== "DRAFT" && selectedEntity && {
        name: "staffStatus",
        label: "Staff Status",
        placeholder: "Staff Status",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: selectedEntity?.staffStatusId === "REJECTED"
            ? [{ value: "DRAFT", label: "DRAFT" }]
            :[
          { value: "DRAFT", label: "DRAFT" },
          { value: "ACTIVE", label: "ACTIVE" },
          { value: "INACTIVE", label: "INACTIVE" },
          { value: "NOTICE PERIOD", label: "NOTICE PERIOD" },
        ],
        rules: [{ required: true, message: "Please enter Staff Status" }],
      },
      {
        name: "employmentMode",
        label: "Employment Mode",
        placeholder: "Employment Mode",
        type: "Select",
        rules: [{ required: true, message: "Please select Employment Mode" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: employmentModes?.map((employmentMode) => ({
          value: employmentMode?.id,
          label: employmentMode?.name,
        })),
      },
      {
        name: "employeeType",
        label: "Employee Type",
        placeholder: "Employee Type",
        type: "Select",
        rules: [{ required: true, message: "Please enter Employee Type" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: employeeTypes?.map((employeeType) => ({
          value: employeeType?.id,
          label: employeeType?.name,
        })),
      },
      showVendorField && {
        name: "vendor",
        label: "Vendor",
        placeholder: "Vendor",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: vendorDropdownOptions,
        rules: [{ required: showVendorField, message: "Please enter Vendor" }],
      },
      showVendorField && {
        name: "vendorEmpId",
        colSpan: colSpan,
        label: "Vendor EMP ID",
        placeholder: "Enter Vendor EMP ID",
        type: "Input",
        allowClear: true,
        rules: [{ required: showVendorField, message: "Please enter Vendor EMP ID" }],
      },
      showVendorField && {
        name: "vendorEmploymentType",
        colSpan: colSpan,
        label: "Vendor Employment Mode",
        placeholder: "Vendor Employment Mode",
        type: "Select",
        showSearch: true,
        allowClear: true,
        options: employmentModes
          .filter((mode) => mode?.name !== "Vendor Consultant")
          .map((mode) => ({ value: mode?.id, label: mode?.name })),
        rules: [{ required: showVendorField, message: "Please enter Vendor Employment Mode" }],
      },

      // {
      //   name: "type",
      //   label: "Staff Type",
      //   placeholder: "Staff Type",
      //   type: "Select",
      //   rules: [{ message: "Please enter Staff Type" }],
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: [
      //     { value: "admin", label: "Admin" },
      //     { value: "hr", label: "HR" }
      //   ],
      // },
      // {
      //   name: 'subtype',
      //   label: 'Staff Sub Type',
      //   placeholder: 'Staff Sub Type',
      //   rules: [{ message: "Please enter Staff Sub Type" }],
      //   type: 'Select',
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: [
      //     { value: 'admin', label: 'Admin' },
      //     { value: "hrmanager", label: "HR Manager" }
      // ],

      // },
      {
        name: "doj",
        label: "Date of Joining",
        placeholder: "Date of Joining",
        type: "DatePicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        rules: [{ required: true, message: "Please enter Date of Joining" }],
      },
      showInternDates && {
        name: "internStartDate",
        label: "Intern Start Date",
        type: "DatePicker",
        colSpan: colSpan,
        disabled: true,
      },
      showInternDates && {
        name: "internEndDate",
        label: "Intern End Date",
        type: "DatePicker",
        colSpan: colSpan,
        disabled: true,
      },
      showTrainingDates && {
        name: "traineeStartDate",
        label: selectedEmploymentModeName.toLowerCase() === "training" ||
          (isVendorConsultant && selectedVendorEmploymentMode?.name?.toLowerCase() === "training")
          ? "Training Start Date"
          : "Trainee Start Date",
        type: "DatePicker",
        colSpan: colSpan,
        disabled: true,
      },
      showTrainingDates && {
        name: "traineeEndDate",
        label: selectedEmploymentModeName.toLowerCase() === "training" ||
          (isVendorConsultant && selectedVendorEmploymentMode?.name?.toLowerCase() === "training")
          ? "Training End Date"
          : "Trainee End Date",
        type: "DatePicker",
        colSpan: colSpan,
        disabled: true,
      },
      // showMalaysiaPassportVisa && {
      //   name: "passportNumber",
      //   label: "Passport Number",
      //   placeholder: "Passport Number",
      //   type: "Input",
      //   colSpan: colSpan,
      //   allowClear: true,
      //   rules: [{ required: true, message: "Please enter Passport Number" }, { pattern: /^[A-Za-z0-9]{6,12}$/, message: "Enter a valid passport number" }],
      // },
      // showMalaysiaPassportVisa && {
      //   name: "passportExpiryDate",
      //   label: "Passport Expiry Date",
      //   placeholder: "Passport Expiry Date",
      //   type: "DatePicker",
      //   colSpan: colSpan,
      //   allowClear: true,
      //   rules: [{ required: true, message: "Please enter Passport Expiry Date" }],
      // },
      // showMalaysiaPassportVisa && {
      //   name: "visaType",
      //   label: "Visa Type",
      //   placeholder: "Visa Type",
      //   type: "Select",
      //   colSpan: colSpan,
      //   allowClear: true,
      //   options: [{ label: "EP (Employment Pass)", value: "EP" }, { label: "RPT (Residence Pass–Talent)", value: "RPT" }],
      //   rules: [{ required: true, message: "Please select Visa Type" }],
      // },
      // showMalaysiaPassportVisa && {
      //   name: "visaExpiryDate",
      //   label: "Visa Expiry Date",
      //   placeholder: "Visa Expiry Date",
      //   type: "DatePicker",
      //   colSpan: colSpan,
      //   allowClear: true,
      //   rules: [{ required: true, message: "Please enter Visa Expiry Date" }],
      // },
      !selectedEntity && showNextReviewDate && {
        name: "nextReviewDate",
        label: "Next Review Date",
        placeholder: "Next Review Date",
        type: "DatePicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,        
        rules: [{ required: showNextReviewDate, message: "Please enter Next Renewal Date" }],
      },
      showContractFields && {
        name: "contractStartDate",
        label: "Contract Start Date",
        placeholder: "Contract Start Date",
        type: "DatePicker",
        colSpan: colSpan,
        disabled: true,
        rules: [{ required: !showNextReviewDate && showContractFields, message: "Please enter Contract Start Date" }],
      },
      showContractFields && {
        name: "contractEndDate",
        label: "Contract End Date",
        placeholder: "Contract End Date",
        type: "DatePicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        dependencies: ["contractStartDate"],
        rules: [
          { required: !showNextReviewDate && showContractFields, message: "Please enter Contract End Date" },
          ({ getFieldValue }: any) => ({
            validator(_: any, value: any) {
              const startDate = getFieldValue("contractStartDate");

              if (value && startDate && dayjs(value).isBefore(dayjs(startDate), "day")) {
                return Promise.reject(
                  new Error("Contract End Date cannot be earlier than Contract Start Date")
                );
              }

              return Promise.resolve();
            },
          }),
        ],
        disabledDate: (current: any) => {
          const contractStartDate = form.getFieldValue("contractStartDate");
          return !!(
            current &&
            contractStartDate &&
            current < dayjs(contractStartDate).startOf("day")
          );
        },
      },
      {
        name: "department",
        label: "Department",
        placeholder: "Department",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: departmentDropdownOptions,
        rules: [{ required: true, message: "Please enter Department" }],
      },
       {
        name: "role",
        colSpan: 12,
        label: "Role",
        placeholder: "Enter Role ",
        type: "Input",
        allowClear: true,
        rules: [
          { required: false, message: "Please enter Role" },
          textOnlyRule("Role"),
        ],
      },
      {
        name: "linemanager",
        label: "Line Manager",
        placeholder: "Line Manager",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: staffDropdownOptions,
        rules: [{ message: "Please enter Line Manager" }],
      },
      // {
      //   name: "client",
      //   label: "Client",
      //   placeholder: "Client",
      //   type: "Select",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: accountList?.map((account) => ({
      //     value: account?.accountId,
      //     label: account?.accountName,
      //   })),
      //   rules: [{ message: "Please enter Client" }],
      // },  
      // {
      //   name: "project",
      //   label: "Project",
      //   placeholder: "Project",
      //   type: "Select",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: projectDropdownOptions,
      //   rules: [{ message: "Please enter Project" }],
      // },
      // // {
      // //   name: "subProject",
      // //   label: "Sub Project",
      // //   placeholder: "Sub Project",
      // //   type: "Select",
      // //   colSpan: colSpan,
      // //   showSearch: true,
      // //   allowClear: true,
      // //   options: projectDropdownOptions,
      // //   rules: [{ message: "Please enter Sub Project" }],
      // // },
      // {
      //   name: "currentProjectStartDate",
      //   label: "Current Project Start Date",
      //   placeholder: "Current Project Start Date",
      //   type: "DatePicker",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   rules: [
      //     { required: false, message: "Please enter Current Project Start Date" },
      //   ],
      // },
      // {
      //   name: "projectReleaseDate",
      //   label: "Project Release Date",
      //   placeholder: "Project Release Date",
      //   type: "DatePicker",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   rules: [
      //     { required: false, message: "Please enter Project Release Date" },
      //   ],
      // },
      // Salary fields are temporarily hidden.
      // !selectedEntity && {
      //   name: "salaryCurrency",
      //   label: "Salary Currency",
      //   placeholder: "Salary Currency",
      //   type: "Select",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: currencies?.map((Currency) => ({
      //     value: Currency?.id,
      //     label: Currency?.name,
      //   })),
      //   rules: [{ required: true, message: "Please enter Salary Currency" }],
      // },
      // !selectedEntity && {
      //   name: "ctc",
      //   colSpan: 12,
      //   label: "CTC (Annual)",
      //   placeholder: "Enter CTC",
      //   type: "InputNumber",
      //   isAmount: true,
      //   allowClear: true,
      //   min: 0,
      //   rules: [{ required: true, message: "Please enter CTC" }],
      // },
      // !selectedEntity && {
      //   name: "employeeCost",
      //   colSpan: 12,
      //   label: "Monthly Salary",
      //   placeholder: "Enter Monthly Salary",
      //   type: "InputNumber",
      //   disabled: true,
      //   isAmount: true,
      //   allowClear: true,
      //   min: 0,
      //   rules: [{ required: false, message: "Please enter Monthly Salary" }],
      // },
      // {
      //   // No `name`: the dragger keeps its own `fileList` state and onFinish
      //   // reads that state directly, so binding this block to the form store
      //   // would only inject unwanted props into the markup below.
      //   label: "Upload File",
      //   type: "Custom",
      //   colSpan: 16,
      //   // The dragger is driven by the `fileList` state below, not by the form
      //   // store, so it is not wrapped in its own Form.Item — an inner Form.Item
      //   // would inject `fileList` onto this plain div and React would warn
      //   // about an unrecognised DOM prop.
      //   render: ({} = {}) => (
      //       <div style={{ maxHeight: 400 }}>
      //         <Upload.Dragger
      //           name="file"
      //           multiple={true}
      //           listType="text"
      //           showUploadList={{ showRemoveIcon: true }}
      //           fileList={fileList}
      //           onChange={handleUploadChange}
      //           onRemove={handleRemove}
      //           customRequest={handleCustomRequest}
      //           beforeUpload={beforeUpload}
      //           accept=".pdf,.doc,.docx"
      //           style={{ padding: "16px 0", backgroundColor: "#dcdcdc" }}
      //           onPreview={async (file) => {
      //             try {
      //               if (file.url) {
      //                 const res = await dispatch(
      //                   getSignedUrl({
      //                     module: "staff",
      //                     params: { url: file.url },
      //                   })
      //                 ).unwrap();

      //                 if (res?.data?.url) {
      //                   window.open(res.data.url, "_blank");
      //                 }
      //               }
      //             } catch (e) {
      //               console.log("Could not open file");
      //             }
      //           }}
      //         >
      //           <p className="ant-upload-drag-icon">
      //             <InboxOutlined />
      //           </p>
      //           <p className="ant-upload-text">
      //             Click or drag file to this area to upload
      //           </p>
      //         </Upload.Dragger>
      //       </div>
      //   ),
      // },
    ],
    extraButtons: [
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Cancel",
        onClick: onClose,
      },
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpan: 5,
        loading: false,
        submitButtonText: "Save",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange,
  };
  return (
    <>
      <Drawer
        maskClosable={false}
        title={<strong>{formProps.heading}</strong>}
        className="form-drawer"
        width={
          screenType.isPortrait
            ? "90%"
            : screenType.isLg || screenType.isXl
            ? 720
            : 500
        }
        onClose={onClose}
        open={visible}
      >
        <GenericFormComponent {...formProps} />
      </Drawer>
    </>
  );
};

export default CreateEditStaffComponent;
